import axios from "axios";
import { GroupedSection, groupSections } from "../util/privacy-policies";
import { isBrowser } from "../util/env-utils";

export type SectionItem = {
  id: number;
  status: "published" | "draft" | "archived";
  sort: number;
  user_created: string;
  date_created: string;
  user_updated?: string;
  date_updated?: string;
  sectionTitle: string;
  sectionContent: string;
  sectionSubTitle?: string;
};

export type RequestPrivacyPoliciesProps = {
  data: SectionItem[];
};

const getBackendEndpoint = () => {
  return (
    (isBrowser ? window.BACKEND_ENDPOINT : undefined) ||
    process.env.BACKEND_ENDPOINT
  );
};

const getCmsProxyPath = () => {
  return (
    (isBrowser ? window.CMS_PROXY_PATH : undefined) ||
    process.env.CMS_PROXY_PATH ||
    "xvia-cms-backend"
  );
};

const BASE_URL = `${getBackendEndpoint()}/api/${getCmsProxyPath()}`;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function getPrivacyPolicies(): Promise<GroupedSection[]> {
  const response = await axiosInstance.get<RequestPrivacyPoliciesProps>(
    `/items/privacy_policies`
  );
  const { data } = response.data;

  const transformedData = groupSections(data);

  return transformedData;
}
